import { createContext } from "react";
import type { AddNotification } from "@inloco/shared";

export interface NotificationContextType {
    addNotification: (value: AddNotification) => void
    removeNotification: (id: string) => void
}

const NotificationContext = createContext<NotificationContextType | null>(null);

export default NotificationContext